module.exports = __webpack_public_path__ + "static/media/chevron-bottom.afd89310.svg";